export enum OperationKinds {
  Add = 1,
  Move,
  Delete,
  Rename,
  Revert,
  Update,
  Revive,
  Redisplay
}
